export var DeliveryOptionType;
(function (DeliveryOptionType) {
    DeliveryOptionType["AtHome"] = "atHome";
    DeliveryOptionType["InStoreJti"] = "InStoreJti";
    DeliveryOptionType["InStoreReservation"] = "InStoreReservation";
    DeliveryOptionType["CustomDeliveryOption"] = "CustomDeliveryOption";
})(DeliveryOptionType || (DeliveryOptionType = {}));
//# sourceMappingURL=Checkout.types.js.map